"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocaleByCountry = getLocaleByCountry;
exports.isSupportedTimezone = isSupportedTimezone;

var _ = require("../");

var _date = require("../date");

var conf = {
  countryBaseInfo: {
    CN: {
      lang: "zh",
      currency: "CNY"
    },
    TW: {
      lang: "zh",
      currency: "TWD"
    },
    HK: {
      lang: "zh,en",
      currency: "HKD"
    },
    US: {
      lang: "en,es",
      currency: "USD"
    },
    BR: {
      lang: "pt",
      currency: "BRL"
    },
    AU: {
      lang: "en",
      currency: "AUD"
    },
    MX: {
      lang: "es",
      currency: "MXN"
    },
    CO: {
      lang: "es",
      currency: "COP"
    },
    JP: {
      lang: "ja",
      currency: "JPY"
    },
    CL: {
      lang: "es",
      currency: "CLP"
    },
    PE: {
      lang: "es",
      currency: "PEN"
    },
    CR: {
      lang: "es",
      currency: "CRC"
    },
    PA: {
      lang: "es",
      currency: "USD"
    },
    RU: {
      lang: "ru",
      currency: "RUB"
    },
    DO: {
      lang: "es",
      currency: "DOP"
    },
    AR: {
      lang: "es",
      currency: "ARS"
    }
  }
}; // export function getLocaleByCountry(country) {
//     return `${conf.countryBaseInfo[country].lang.split(',')[0]}_${country}`;
// }
// 根据用户传入的国家码获取默认locale

function getLocaleByCountry(country) {
  if (!country) {
    throw Error("Elvish Error: please call getLocaleByCountry function with country parameter first");
  } // 当传入错误的国家，就取用户init时的locale


  return _._apollo.countryBaseInfo[country] ? "".concat(_._apollo.countryBaseInfo[country].lang.split(',')[0], "-").concat(country) : _._locale;
} // 判断是否为elvish支持的timezone


function isSupportedTimezone(timezone) {
  if (!timezone) {
    throw Error("Elvish Error: please call isSupportedTimezone function with timezone parameter first");
  }

  return _date.timeZoneList.timezones[timezone] ? true : false;
}